/**
 * resusable component to create and edit resource links
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import actions
import * as resourceLinkActions from '../resourceLinkActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';

import {
  TextInput
  , UrlInput
} from '../../../global/components/forms';

import resourceLinktyles from '../resourceLinkModuleStyles.css';

class ResourceLinkModal extends Base {
  constructor(props) {
    super(props);
    this.state = {
      newResourceLink: _.cloneDeep(this.props.resourceLink)
    }
    this._bind(
      '_cancelChanges'
      , '_handleFormChange'
      , '_handleSave'
    )
  }

  _cancelChanges() {
    this.setState({
      newResourceLink: _.cloneDeep(this.props.resourceLink)
    })
    this.props.closeModal()
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleSave() {
    const { closeModal, dispatch, formType, refId, refKey } = this.props;
    let newRLink = {...this.state.newResourceLink};
    if(formType === 'Create') {
      newRLink[refKey] = refId;
      dispatch(resourceLinkActions.sendCreateResourceLink(newRLink)).then(action => {
        if(action.success) {
          console.log('success');
          dispatch(resourceLinkActions.invalidateList(refKey, refId));
          closeModal()
        } else {
          alert(`ERROR: ${action.error}`);
        }
      })
    } else {
      dispatch(resourceLinkActions.sendUpdateResourceLink(newRLink)).then(action => {
        if(action.success) {
          console.log('success');
          dispatch(resourceLinkActions.invalidateList(refKey, refId));
        } else {
          alert(`ERROR: ${action.error}`);
        }
      })
    }
  }

  render() {
    const { formType, isOpen, resourceLink } = this.props;
    const { newResourceLink } = this.state;
    return (
      <Modal
        cardSize='standard'
        closeAction={this._cancelChanges}
        closeText="Cancel changes"
        confirmAction={this._handleSave}
        confirmText="Save"
        disableConfirm={this.state.newResourceLink.url.length < 1 || this.state.newResourceLink.name.length < 1 || _.isEqual(this.state.newResourceLink, this.props.resourceLink)}
        isOpen={isOpen}
        modalHeader={`${formType} resource link`}
        showButtons={true}
      >
        <div styleName="-resource-link-form">
          <h3>Resource Link</h3>
          <div className="yt-col full s_60">
            <TextInput
              change={this._handleFormChange}
              label="Display name"
              name="newResourceLink.name"
              required={true}
              value={newResourceLink.name}
            />
            <UrlInput
              change={this._handleFormChange}
              label="Link URL"
              name="newResourceLink.url"
              required={true}
              validate={false}
              value={newResourceLink.url}
            />
          </div>
        </div>
      </Modal>
    )
  }
}

ResourceLinkModal.propTypes = {
  closeModal: PropTypes.func.isRequired
  , dispatch: PropTypes.func.isRequired
  , formType: PropTypes.string
  , isOpen: PropTypes.bool
  , refId: PropTypes.string.isRequired
  , refKey: PropTypes.oneOf([
    '_course'
    , '_scene'
    , '_group'
    , '_contentModule'
  ]).isRequired
  , resourceLink: PropTypes.object.isRequired
}

ResourceLinkModal.defaultProps = {
  formType: 'Create'
  , isOpen: false
}


export default ResourceLinkModal;



// WEBPACK FOOTER //
// modules/resourceLink/components/ResourceLinkModal.js.jsx